class CartRelatedProducts extends HTMLElement {
  constructor() {
    super();
    this.desktop_column = parseInt(this.dataset.desktop_column, 10) || 1;
    this.products_to_show = this.dataset.products_to_show;
  }

  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';

    // Skip if this element was rendered as part of a sub-fetch response
    if (this.querySelector('.swiper-slide') && !this.dataset.productIds) return;

    const productIds = (this.dataset.productIds || '')
      .split(',').map(s => s.trim()).filter(Boolean);

    if (productIds.length === 0) {
      this.innerHTML = '';
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.unobserve(this);
        this.init(productIds);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    observer.observe(this);
  }

  async init(productIds) {
    const sectionId = this.dataset.sectionId;
    const fetchUrl = this.dataset.fetchUrl;
    const limit = parseInt(this.products_to_show || '4', 10);
    const perProductLimit = Math.max(limit, 4);

    try {
      const responses = await Promise.all(
        productIds.map(id =>
          fetch(`${fetchUrl}?section_id=${sectionId}&product_id=${id}&limit=${perProductLimit}&intent=related`)
            .then(r => (r.ok ? r.text() : ''))
            .catch(() => '')
        )
      );

      const excludeIds = new Set(productIds);
      const seenHandles = new Set();
      const allSlides = [];
      let shellHtml = null;

      responses.forEach(html => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('cart-related-products');
        if (!inner) return;

        if (!shellHtml && inner.innerHTML.trim()) {
          shellHtml = inner.innerHTML;
        }

        inner.querySelectorAll('.swiper-slide').forEach(slide => {
          const handle = this.getProductHandle(slide);
          const pid = this.getProductId(slide);

          if (pid && excludeIds.has(pid)) return;
          if (handle && seenHandles.has(handle)) return;
          if (handle) seenHandles.add(handle);

          allSlides.push(slide);
        });
      });

      if (allSlides.length === 0 || !shellHtml) {
        this.innerHTML = '';
        return;
      }

      // Fisher–Yates shuffle
      for (let i = allSlides.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [allSlides[i], allSlides[j]] = [allSlides[j], allSlides[i]];
      }

      const finalSlides = allSlides.slice(0, limit);

      this.innerHTML = shellHtml;

      const wrapper = this.querySelector('.swiper-wrapper');
      if (wrapper) {
        wrapper.innerHTML = '';
        finalSlides.forEach(slide => wrapper.appendChild(slide));
      }

      this.classList.add('product-recommendations--loaded');

      // ===== Swiper init (mirror of global.js) =====
      let swiper = null;
      const tabletSlides = 2;
      const desktopSlides = (this.desktop_column > 2) ? this.desktop_column : tabletSlides;
      const initSwiper = () => {
        if (window.innerWidth >= 750 && !swiper) {
          swiper = new Swiper('.product-slider__swiper', {
            observer: true,
            observeParents: true,
            loop: true,
            spaceBetween: 28,
            speed: 800,
            mousewheel: {
              enabled: true,
              forceToAxis: true
            },
            navigation: {
              nextEl: '.related-products__next',
              prevEl: '.related-products__prev'
            },
            slidesPerView: tabletSlides,
            breakpoints: {
              1024: {
                slidesPerView: desktopSlides
              }
            }
          });
        } else if (window.innerWidth < 750 && swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
      };

      initSwiper();
      window.addEventListener('resize', initSwiper);
      // =============================================

    } catch (err) {
      console.error('[cart-related-products]', err);
      this.innerHTML = '';
    }
  }

  getProductHandle(slide) {
    const link = slide.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  getProductId(slide) {
    const el = slide.querySelector('[data-product-id]');
    return el ? el.dataset.productId : null;
  }
}

if (!customElements.get('cart-related-products')) {
  customElements.define('cart-related-products', CartRelatedProducts);
}